import { getLocalTimeZone, type DateValue } from '@internationalized/date';

export const toSingleDate = (date: DateValue | DateValue[] | undefined): DateValue | undefined =>
    Array.isArray(date) ? date[0] : date;

export const formatDateLabel = (date: DateValue, locale: string | undefined, options: Intl.DateTimeFormatOptions): string =>
    new Intl.DateTimeFormat(locale, options).format(date.toDate(getLocalTimeZone()));
